import { Separator } from '@radix-ui/react-separator';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import AppSidebar from '../app-sidebar';
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbPage } from '../ui/breadcrumb';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '../ui/sidebar';
import useAuth from '../../stores/useAuth';
import { LOGIN_PAGE } from '../../routes/routeConstant';

export default function LayoutAdmin({ children, header }: { children: React.ReactNode; header?: string }) {
  const { isAuthenticated, checkAuth, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (loading && !isAuthenticated) {
    return (
      <div className="flex w-full h-dvh justify-center items-center">
        <div className="flex animate-pulse aspect-square size-32 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
          <img src="/assets/MSA-Logo.jpg" alt="MSA-Logo" className="rounded" />
        </div>
      </div>
    );
  }

  if (!loading && !isAuthenticated) {
    navigate(LOGIN_PAGE, { replace: true });
    return null;
  }
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-base md:text-xl">{header}</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
}
